import { actionsStyles } from "@insite/content-library/Widgets/ProductList/ProductListTable";
import { css } from "styled-components";

actionsStyles.availabilityStyles = {
    messageGridItem: {
        width: 12,
    },
    availabilityByWarehouseLinkGridItem: {
        width: 12,
        css: css`
            margin-top: 10px !important;
            margin-bottom: 5px !important;
            margin-left: 5px !important;
        `
    },
    messageText: {
        css: css`
            white-space: nowrap;
        `,
    },
}